import React from 'react';
import { cn } from '../../utils/cn';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  variant?: 'default' | 'elevated' | 'outline';
}
export function Card({
  children,
  className,
  variant = 'default',
  ...props
}: CardProps) {
  const baseStyles = 'rounded-2xl overflow-hidden';
  const variants = {
    default: 'bg-cream border border-beige',
    elevated: 'bg-cream shadow-soft',
    outline: 'bg-transparent border border-gold/30'
  };
  return <div className={cn(baseStyles, variants[variant], className)} {...props} data-id="element-274">
      {children}
    </div>;
}